define([
    "views/common/vn_modal_view",
    "jquery",
    "underscore",
    "marionette",
], function (VnModalView, $, _, Marionette) {
    let timerMs = 300000;
    let intervalId;
    return Marionette.View.extend({
        el: "#content_layout",

        ui: {
            //for account/info_promotion_ndb.php
            closeModal: "#close-modal-promotion-popup-ndb",
            accountSelect: "#account-select",
            bonusAmount: "#bonus_amount",
            currency: "#currency",
            receiveBonus: "#receive-bonus",

            //for account/info.php
            moreAccountBtn: "#more_account_btn",
            moreBtn: ".more-btn",
            newSelectBox: ".new-select-box",
            archiveAccountMenu: '.archive_account_menu',
            archiveAccountModal: '#remove_account',
            archiveAccountCancelBtn: '#archive_account_cancel_btn',
            archiveAccountBtn: '#archive_account_btn',

            emailVerificationModal: '#email_verification_modal',
            emailVerificationCancelBtn: '#email_verification_cancel_btn',
            emailVerificationBtn: '#email_verification_btn',
            emailCodeInput: '#input-email-code',

            secureVerificationCdInput: '#secure_verification_cd',
            errorMsgWrapper: '#error_msg_wrapper',

            changePasswordMenu: '.change_password_menu',
            changeReadonlyPasswordMenu: '.change_readonly_password_menu',

            additionalAccountBox: '#box_additional_account',
            additionalAccountBtn: '#btn_additional_account',
            showProfilePageBtn: '#btn_show_profile',
            idVerificationFirstModal: '#id_verification_first_modal',
            notAllowedRemoveAccountModal: '#not_allowed_remove_modal',

            inputHiddenAccountNo: '#hidden_account_no',

            ibCannotBeRemovedTextWrapper: '#modal-content-ib-cannot-be-removed',

            //for account/change_password_modal.php
            changePasswordModal: '#change_password',
            changePasswordAccountNoSpan: '#change_password_account_no',
            passwordInput: '#password',
            confirmPasswordInput: '#confirm_password',
            showPasswordTextBtn: '#show_password_btn_img',
            showConfirmPasswordTextBtn: '#show_confirm_password_btn_img',
            removePasswordTextBtn: '#remove_password_btn_img',
            removeConfirmPasswordTextBtn: '#remove_confirm_password_btn_img',
            validationUppercase: '#validation_uppercase',
            validationSpeicalCharacter: '#validation_specialChar',
            validationNumber: '#validation_number',
            validationLength: '#validation_length',
            validationConfirm: '#validation_confirm',
            showStep2Btn: '#btn_show_step2',
            changePasswordStep2Modal: '#change_password_step2',
            changePasswordStep2AccountNoSpan: '#change_password_step2_account_no',
            changePasswordStep2Input: '#verification_code',
            changePasswordSubmitBtn: '#btn_change_password_submit',
            emailCodeTimer: '#timer_email_code',

            toastSuccess: '#toast_success',
            toastSuccessText: '#toast_text_success',
            toastFail: '#toast_fail',
            toastFailText: '#toast_text_fail',

            // readonly password
            changePasswordTitle: '#change-password-title',
            readonlyPasswordMustDiffer: '#readonly-password-must-differ',
        },

        showNotAllowedRemoveAccountModal: function () {
            this.ui.notAllowedRemoveAccountModal.modal({show: true});
        },

        showIdVerificationFirstModal: function () {
            this.ui.idVerificationFirstModal.modal({show: true});
        },

        redirectToAdditionalAccountPage: function (e) {
            if (e) e.preventDefault()

            let target = $(e.target)

            if (target.is('p') || target.is('img'))
                target = target.closest('a')

            if (target.hasClass('inactive'))
                return;

            if (window.is_account_verified != 1) {
                this.showIdVerificationFirstModal()
                return;
            }

            window.location.href = "/account/additional_account"
        },

        redirectToProfilePage: function (e) {
            window.location.href = "/profile/verification"
        },

        events: {
            'click @ui.additionalAccountBox': 'redirectToAdditionalAccountPage',
            'click @ui.showProfilePageBtn': 'redirectToProfilePage',
            "click @ui.additionalAccountBtn": 'redirectToAdditionalAccountPage',

            "click @ui.changePasswordMenu": 'showChangePasswordModal',
            "click @ui.changeReadonlyPasswordMenu": 'showReadonlyChangePasswordModal',
            "keyup @ui.passwordInput": 'validatePasswordInputText',
            "keyup @ui.confirmPasswordInput": "validateConfirmPasswordInputText",
            "click @ui.showPasswordTextBtn": 'changePasswordInputType',
            "click @ui.showConfirmPasswordTextBtn": 'changeConfirmPasswordInputType',
            "click @ui.removePasswordTextBtn": 'removePasswordInputValue',
            "click @ui.removeConfirmPasswordTextBtn": 'removeConfirmPasswordInputValue',
            "click @ui.showStep2Btn": "showStep2Modal",
            "keyup @ui.changePasswordStep2Input": 'validateChangePasswordStep2Code',
            'click @ui.changePasswordSubmitBtn': 'requestChangePassword',

            "click @ui.moreAccountBtn": function (e) {
                this.getMoreAccounts();
            },

            "click @ui.closeModal": function (e) {
                this.closeModal(e);
            },

            'change @ui.accountSelect': function (e) {
                this.accountSelect(e);
            },

            "click @ui.receiveBonus": function (e) {
                this.receiveBonus(e);
            },

            "click @ui.moreBtn": function (e) {
                this.displayAccountSelectBox(e);
            },

            "click @ui.newSelectBox": function (e) {
                this.displaySorterSelectBox(e);
            },

            "click": function (e) {
                this.UnDisplaySelectBox(e);
            },

            'click @ui.archiveAccountMenu': function (e) {
                if (e) e.preventDefault();

                if (window.accounts_count <= 1) {
                    this.showNotAllowedRemoveAccountModal()
                    return;
                }

                this.showArchiveAccountModal(e);
            },

            'click @ui.archiveAccountCancelBtn': function (e) {
                this.hideArchiveAccountModal(e);
            },

            'click @ui.archiveAccountBtn': function (e) {
                this.sendEmailVerification(e);
            },

            'click @ui.emailVerificationBtn': function (e) {
                this.verifyEmailCode(e);
            },

            'click @ui.emailVerificationCancelBtn': function (e) {
                this.hideEmailVerificationModal(e);
            },

            'keyup @ui.emailCodeInput': function (e) {
                if (this.validateEmailCode(e))
                    this.ui.emailVerificationBtn.attr('disabled', false)
                else
                    this.ui.emailVerificationBtn.attr('disabled', true)
            }
        },

        initialize: function () {
            this.vnPromoModal = new VnModalView();
            this.bindUIElements();
            this.passwordModalType = null; // null / write / readonly
        },

        getMoreAccounts: function () {
            $('.account-box-hidden').removeClass('account-box-hidden');
            $("#more_account_btn").hide();
        },

        closeModal: function (e) {
            if (e) e.preventDefault();

            $("#promotion-popup-ndb").css("display", "none");
        },

        accountSelect: function (e) {
            e.preventDefault();

            var selectedIndex = this.ui.accountSelect[0].selectedIndex;
            var selectAccountInfo = window.receivable_account_info[selectedIndex];

            $("#account-select-value").text(selectAccountInfo.currencySymbol + ' ' + selectAccountInfo.bonusAmount);

            this.ui.currency.val(selectAccountInfo.currency);
            this.ui.bonusAmount.val(selectAccountInfo.bonusAmount);
        },

        receiveBonus: function (e) {
            if (e) e.preventDefault();
            var that = this;

            $.ajax("/rest_account/receive_bonus", {
                method: "POST",
                data: {
                    received_account_no: this.ui.accountSelect.val(),
                    currency: this.ui.currency.val(),
                    bonus_amount: this.ui.bonusAmount.val(),
                },
                success: function (data) {
                    alert(data.message);
                    $("#promotion-popup-ndb").css("display", "none");
                },
                error: function (xhr, textStatus, errorThrown) {
                    var error = xhr.responseJSON;

                    alert(error);
                },
            });
        },

        displayAccountSelectBox: function (e) {
            e.stopPropagation();
            const accountId = e.currentTarget.children[1].id;
            const selectBoxs = document.querySelectorAll(".more-btn ul")
            const targetSelectBox = document.querySelector(`#${accountId}`);

            if (targetSelectBox.style.display === "none") {
                for (const selectBox of selectBoxs) {
                    selectBox.style.display = "none";
                }
                targetSelectBox.style.display = "block";
            } else {
                targetSelectBox.style.display = "none";
            }
        },

        displaySorterSelectBox: function (e) {
            e.stopPropagation();
            const selectBox = document.querySelector("#account_sorter_select_box")
            if (selectBox.style.display === "block") {
                selectBox.style.display = "none";
            } else {
                selectBox.style.display = "block";
            }
        },

        UnDisplaySelectBox: function (e) {
            // unDisplay sorter select box
            const sorterSelectBox = document.querySelector("#account_sorter_select_box")
            sorterSelectBox.style.display = 'none';

            // unDisplay account select boxes
            const accountSelectBoxes = document.querySelectorAll('.more-btn ul')
            for (const selectBox of accountSelectBoxes) {
                selectBox.style.display = 'none';
            }
        },

        showArchiveAccountModal: function (e) {
            e.preventDefault();
            const that = this;
            const mt4AccountNo = $(e.target).data('account');
            const balance = $(e.target).data('balance');
            const currencyAbbr = $(e.target).data('currency');

            // open modal
            const $ArchiveAccountModal = that.ui.archiveAccountModal
            $ArchiveAccountModal.modal({
                show: true
            });

            // set mt4AccountNo in modal text
            const $accountHighlight = document.querySelector('.account-highlight')
            $accountHighlight.innerHTML = mt4AccountNo;

            const $balanceHighlight = document.querySelector('.balance-highlight')
            $balanceHighlight.innerHTML = `${balance} ${currencyAbbr}`

            // set mt4AccountNo in value
            const $archiveAccountBtn = document.querySelector('#archive_account_btn')
            $archiveAccountBtn.value = mt4AccountNo;

            that.ui.inputHiddenAccountNo.val(mt4AccountNo)

            const isIb = $(e.target).data('isib')
            if (isIb == 1) {
                that.ui.ibCannotBeRemovedTextWrapper.show()
                that.ui.archiveAccountBtn.prop('disabled', true)
            } else {
                that.ui.ibCannotBeRemovedTextWrapper.hide()
                that.ui.archiveAccountBtn.prop('disabled', false)
            }
        },

        hideArchiveAccountModal: function (e) {
            e.preventDefault();
            const that = this;
            that.ui.archiveAccountModal.modal('hide');
        },

        archiveAccount: function (e) {
            if (e) e.preventDefault();
            var that = this;
            var mt4Account = that.ui.inputHiddenAccountNo.val()

            $('#holdon-overlay').css("display", "");

            $.ajax("/rest_account/archive_mt4_account", {
                method: "POST",
                data: {
                    mt4_account_no: mt4Account,
                },
                success: function (data) {
                    location.reload();
                },
                error: function (xhr, textStatus, errorThrown) {
                    $('#holdon-overlay').css("display", "none");

                    var error = xhr.responseJSON;

                    alert(error.error_message);
                },
            });
        },

        verifyEmailCode: function (e) {
            if (e) e.preventDefault();

            const that = this;

            $('#holdon-overlay').css("display", "");
            that.ui.errorMsgWrapper.css('display', 'none');

            $.ajax('/rest_account/verify_email_code', {
                method: "POST",
                data: {
                    'secureVerificationCd': that.ui.secureVerificationCdInput.val(),
                    'code': that.ui.emailCodeInput.val()
                },
                success: function (data) {
                    $('#holdon-overlay').css("display", "none");
                    that.hideEmailVerificationModal(e);
                    that.archiveAccount(e);
                },
                error: function (xhr, textStatus, errorThrown) {
                    $('#holdon-overlay').css("display", "none");
                    that.ui.errorMsgWrapper.css('display', '');
                }
            })
        },

        validateEmailCode: function (e) {
            if (e) e.preventDefault();

            const inputValue = this.ui.emailCodeInput.val()

            if (!inputValue)
                return false;

            return /^\d{4}$/.test(inputValue);
        },

        // zzzzz
        validatePasswordByBackend: function (e) {
            if (e) e.preventDefault();
            const that = this;

            $('#holdon-overlay').css("display", "");

            const mt4Account = that.ui.inputHiddenAccountNo.val()
            const newPassword = that.ui.passwordInput.val()
            const confirmNewPassword = that.ui.passwordInput.val()

            $.ajax("/rest_account/validate_password_by_backend", {
                method: "POST",
                data: {
                    mt4_account_no: mt4Account,
                    new_password: newPassword,
                    confirm_new_password: confirmNewPassword
                },
                success: function (data) {
                    $('#holdon-overlay').css("display", "none");
                    that.ui.changePasswordStep2Modal.modal('hide');
                    that.sendEmailVerification(e, 'change_password')
                },
                error: function (xhr, textStatus, errorThrown) {
                    $('#holdon-overlay').css("display", "none");
                    var error = xhr.responseJSON;
                    that.toastFail(error.error_code, 'change_password')
                },
            });
        },

        sendEmailVerification: function (e, type = 'archive') {
            if (e) e.preventDefault();
            const that = this;

            $('#holdon-overlay').css("display", "");

            $.ajax("/rest_account/send_email_verification", {
                method: "POST",
                success: function (data) {
                    $('#holdon-overlay').css("display", "none");
                    that.ui.secureVerificationCdInput.val(data.secureVerificationCd);

                    if (type == 'archive') {
                        that.hideArchiveAccountModal(e);
                        that.showEmailVerificationModal(e);
                    } else if (type == 'change_password') {
                        that.ui.changePasswordModal.modal('hide')
                        that.showChangePasswordStep2Modal()
                    }
                },
                error: function (xhr, textStatus, errorThrown) {
                    $('#holdon-overlay').css("display", "none");
                    var error = xhr.responseJSON;
                    alert(error.msg);
                },
            });
        },

        showEmailVerificationModal: function (e) {
            e.preventDefault();
            const that = this;

            const $emailVerificationModal = that.ui.emailVerificationModal
            $emailVerificationModal.modal({
                show: true
            });
        },

        hideEmailVerificationModal: function (e) {
            e.preventDefault();
            const that = this;
            that.ui.emailVerificationModal.modal('hide');
            that.ui.errorMsgWrapper.css('display', 'none');
            that.ui.emailCodeInput.val('');
        },

        // show first modal for write
        showChangePasswordModal: function (e) {
            this.passwordModalType = 'write'

            e.preventDefault();
            const mt4AccountNo = $(e.target).data('account');

            this.ui.changePasswordTitle.text(window.translations.ChangePassword_Title_Write)
            this.ui.readonlyPasswordMustDiffer.css('display', 'none')

            this.ui.inputHiddenAccountNo.val(mt4AccountNo);
            this.ui.changePasswordAccountNoSpan.text(mt4AccountNo);
            this.ui.changePasswordStep2AccountNoSpan.text(mt4AccountNo);
            this.ui.changePasswordModal.modal({show: true});

            this.removePasswordInputValue(e)
            this.removeConfirmPasswordInputValue(e)
            this.removeChangePasswordStep2InputValue(e);
        },

        // show first modal for readonly
        showReadonlyChangePasswordModal: function (e) {
            this.passwordModalType = 'readonly'

            e.preventDefault();
            const mt4AccountNo = $(e.target).data('account');

            this.ui.changePasswordTitle.text(window.translations.ChangePassword_Title_Readonly)
            this.ui.readonlyPasswordMustDiffer.css('display', 'flex')

            this.ui.inputHiddenAccountNo.val(mt4AccountNo);
            this.ui.changePasswordAccountNoSpan.text(mt4AccountNo);
            this.ui.changePasswordModal.modal({show: true});

            this.removePasswordInputValue(e)
            this.removeConfirmPasswordInputValue(e)
        },        

        changePasswordInputType: function (e) {
            const currentType = this.ui.passwordInput.attr('type')
            if (currentType == 'password') {
                this.ui.passwordInput.attr('type', 'text')
                this.ui.showPasswordTextBtn.attr('src', '/assets/common/common/img/hide_eye_gray.svg')
            } else {
                this.ui.passwordInput.attr('type', 'password')
                this.ui.showPasswordTextBtn.attr('src', '/assets/common/common/img/eye_icon_gray.svg')
            }
        },

        changeConfirmPasswordInputType: function (e) {
            const currentType = this.ui.confirmPasswordInput.attr('type')
            if (currentType == 'password') {
                this.ui.confirmPasswordInput.attr('type', 'text')
                this.ui.showConfirmPasswordTextBtn.attr('src', '/assets/common/common/img/hide_eye_gray.svg')
            } else {
                this.ui.confirmPasswordInput.attr('type', 'password')
                this.ui.showConfirmPasswordTextBtn.attr('src', '/assets/common/common/img/eye_icon_gray.svg')
            }
        },

        validatePassowrdTexts() {
            const password = this.ui.passwordInput.val()
            const confirmPassword = this.ui.confirmPasswordInput.val()

            const lengthRule = /^.{8,15}$/;
            const digitRule = /\d/;
            const specialCharRule = /[!@#$%^*+=-]+/;
            const uppercaseRule = /(?=.*[a-z])(?=.*[A-Z])/;

            if (password != confirmPassword) {
                this.ui.showStep2Btn.removeClass('active')
                return;
            }

            if (lengthRule.test(password) && digitRule.test(password) &&
                specialCharRule.test(password) && uppercaseRule.test(password)) {
                this.ui.showStep2Btn.addClass('active')
            } else
                this.ui.showStep2Btn.removeClass('active')
        },

        validatePasswordInputText(e) {
            const password = e.target.value;

            // password text가 없을때 validation 모두 숨김
            if (!password || password.length < 1) {
                this.ui.validationUppercase.removeClass('satisfied')
                this.ui.validationUppercase.css('display', 'none')
                this.ui.validationSpeicalCharacter.removeClass('satisfied')
                this.ui.validationSpeicalCharacter.css('display', 'none')
                this.ui.validationNumber.removeClass('satisfied')
                this.ui.validationNumber.css('display', 'none')
                this.ui.validationLength.removeClass('satisfied')
                this.ui.validationLength.css('display', 'none')
                this.validatePassowrdTexts()
                return;
            }

            // 글자수 8자 이상, 15자 이하
            const lengthRule = /^.{8,15}$/;
            if (lengthRule.test(password)) {
                this.ui.validationLength.addClass('satisfied')
                this.ui.validationLength.css('display', 'flex')
            } else {
                this.ui.validationLength.removeClass('satisfied')
                this.ui.validationLength.css('display', 'flex')
            }

            // 숫자 하나 이상 포함
            const digitRule = /\d/;
            if (digitRule.test(password)) {
                this.ui.validationNumber.addClass('satisfied')
                this.ui.validationNumber.css('display', 'flex')
            } else {
                this.ui.validationNumber.removeClass('satisfied')
                this.ui.validationNumber.css('display', 'flex')
            }

            // 특수문자 하나 이상 포함
            const specialCharRule = /[!@#$%^*+=-]+/;
            if (specialCharRule.test(password)) {
                this.ui.validationSpeicalCharacter.addClass('satisfied')
                this.ui.validationSpeicalCharacter.css('display', 'flex')
            } else {
                this.ui.validationSpeicalCharacter.removeClass('satisfied')
                this.ui.validationSpeicalCharacter.css('display', 'flex')
            }

            // 영문 대문자/소문자 포함
            const uppercaseRule = /(?=.*[a-z])(?=.*[A-Z])/;
            if (uppercaseRule.test(password)) {
                this.ui.validationUppercase.addClass('satisfied')
                this.ui.validationUppercase.css('display', 'flex')
            } else {
                this.ui.validationUppercase.removeClass('satisfied')
                this.ui.validationUppercase.css('display', 'flex')
            }

            this.validateConfirmPasswordInputText();
            this.validatePassowrdTexts()
        },

        validateConfirmPasswordInputText(e) {
            if (e) e.preventDefault();
            const confirmPassword = this.ui.confirmPasswordInput.val();
            const password = this.ui.passwordInput.val()

            if (!confirmPassword || confirmPassword.length < 1) {
                this.ui.validationConfirm.removeClass('satisfied')
                this.ui.validationConfirm.css('display', 'none')
                this.ui.validationConfirm.text(window.translations.Register_PWdonotmatch)
                this.validatePassowrdTexts()
                return;
            }

            if (password == confirmPassword) {
                this.ui.validationConfirm.addClass('satisfied')
                this.ui.validationConfirm.css('display', 'flex')
                this.ui.validationConfirm.text(window.translations.Register_PWmatch)
            } else {
                this.ui.validationConfirm.removeClass('satisfied')
                this.ui.validationConfirm.css('display', 'flex')
                this.ui.validationConfirm.text(window.translations.Register_PWdonotmatch)
            }

            this.validatePassowrdTexts()
        },

        removePasswordInputValue(e) {
            if (e) e.preventDefault()
            this.ui.passwordInput.val('');
            this.ui.validationUppercase.removeClass('satisfied')
            this.ui.validationUppercase.css('display', 'none')
            this.ui.validationSpeicalCharacter.removeClass('satisfied')
            this.ui.validationSpeicalCharacter.css('display', 'none')
            this.ui.validationNumber.removeClass('satisfied')
            this.ui.validationNumber.css('display', 'none')
            this.ui.validationLength.removeClass('satisfied')
            this.ui.validationLength.css('display', 'none')
            this.ui.validationConfirm.removeClass('satisfied')
            this.ui.validationConfirm.text(window.translations.Register_PWdonotmatch)
            this.ui.showStep2Btn.removeClass('active')
        },

        removeConfirmPasswordInputValue(e) {
            if (e) e.preventDefault()
            this.ui.confirmPasswordInput.val('');
            this.ui.validationConfirm.removeClass('satisfied')
            this.ui.validationConfirm.css('display', 'none')
            this.ui.validationConfirm.text(window.translations.Register_PWdonotmatch)
            this.ui.showStep2Btn.removeClass('active')
        },

        // write password: validate password and show second modal
        // readonly password: or excute change password
        showStep2Modal(e) {
            if (e) e.preventDefault();
            const that = this;

            if (!this.ui.showStep2Btn.hasClass('active')) {
                return;
            }

            that.ui.changePasswordStep2Modal.data('ps', this.ui.passwordInput.val());

            if (this.passwordModalType == 'write') {
                that.validatePasswordByBackend(e)
            } else if (this.passwordModalType == 'readonly') {
                that.changeReadonlyPassword(e)
            } else {
                return;
            }
        },

        showChangePasswordStep2Modal: function () {
            const that = this;

            that.ui.changePasswordStep2Modal.modal({show: true})

            // 5min timer
            timerMs = 300000
            if (intervalId) {
                clearInterval(intervalId)
                that.ui.emailCodeTimer.text('')
            }

            intervalId = setInterval(() => {
                timerMs -= 1000
                const timeText = that.msToTime(timerMs)
                that.ui.emailCodeTimer.text(timeText)
                if (timerMs <= 0) {
                    that.ui.changePasswordSubmitBtn.removeClass('active')
                    clearInterval(intervalId);
                }
            }, 1000)
        },

        msToTime: function (duration) {
            let seconds = Math.floor((duration / 1000) % 60),
                minutes = Math.floor((duration / (1000 * 60)) % 60);

            minutes = (minutes < 10) ? "0" + minutes : minutes;
            seconds = (seconds < 10) ? "0" + seconds : seconds;

            return minutes + ":" + seconds;
        },

        validateChangePasswordStep2Code: function (e) {
            if (e) e.preventDefault();

            const inputValue = this.ui.changePasswordStep2Input.val()
            if (!inputValue)
                return false;

            if (/^\d{4}$/.test(inputValue) && intervalId && timerMs > 0)
                this.ui.changePasswordSubmitBtn.addClass('active')
            else
                this.ui.changePasswordSubmitBtn.removeClass('active')
        },

        requestChangePassword: function (e) {
            if (e) e.preventDefault();

            if (!this.ui.changePasswordSubmitBtn.hasClass('active'))
                return;

            this.changePassword(e)
        },

        changePassword: function (e) {
            if (e) e.preventDefault();
            const that = this;

            $('#holdon-overlay').css("display", "");

            const mt4Account = that.ui.inputHiddenAccountNo.val()
            const newPassword = that.ui.passwordInput.val()
            const confirmNewPassword = that.ui.passwordInput.val()
            const code = that.ui.changePasswordStep2Input.val()
            const secureVerificationCode = that.ui.secureVerificationCdInput.val()

            $.ajax("/rest_account/change_password", {
                method: "POST",
                data: {
                    mt4_account_no: mt4Account,
                    new_password: newPassword,
                    confirm_new_password: confirmNewPassword,
                    code,
                    secure_verification_cd: secureVerificationCode
                },
                success: function (data) {
                    $('#holdon-overlay').css("display", "none");
                    that.ui.changePasswordStep2Modal.modal('hide');
                    that.toastSuccess()
                },
                error: function (xhr, textStatus, errorThrown) {
                    $('#holdon-overlay').css("display", "none");
                    var error = xhr.responseJSON;
                    that.toastFail(error.error_code, 'change_password')
                },
            });
        },

        changeReadonlyPassword: function (e) {
            if (e) e.preventDefault();
            const that = this;

            $('#holdon-overlay').css("display", "");

            const mt4Account = that.ui.inputHiddenAccountNo.val()
            const newPassword = that.ui.passwordInput.val()
            const confirmNewPassword = that.ui.passwordInput.val()

            $.ajax("/rest_account/change_readonly_password", {
                method: "POST",
                data: {
                    mt4_account_no: mt4Account,
                    new_password: newPassword,
                    confirm_new_password: confirmNewPassword,
                },
                success: function (data) {
                    $('#holdon-overlay').css("display", "none");
                    that.ui.changePasswordModal.modal('hide');
                    that.toastSuccess()
                },
                error: function (xhr, textStatus, errorThrown) {
                    $('#holdon-overlay').css("display", "none");
                    var error = xhr.responseJSON;
                    that.toastFail(error.error_code, 'change_readonly_password')
                },
            });
        },

        removeChangePasswordStep2InputValue: function (e) {
            this.ui.changePasswordStep2Input.val('')
            this.ui.changePasswordSubmitBtn.removeClass('active')
        },

        toastSuccess: function () {
            const mt4Account = this.ui.changePasswordAccountNoSpan.text()
            let html
            if (this.passwordModalType == 'readonly') {
                html = window.translations.AccountNo + ' ' + mt4Account + '<br/>' + window.translations.ChangePassword_Toast_Success_Readonly
            } else {
                html = window.translations.AccountNo + ' ' + mt4Account + '<br/>' + window.translations.ChangePassword_Toast_Success
            }
            this.ui.toastSuccessText.html(html)
            this.ui.toastSuccess.addClass('show')

            const that = this
            setTimeout(() => {
                that.ui.toastSuccess.removeClass('show')
            }, 5000)
        },

        toastFail: function (backendErrorCode, apiType) {
            const mt4Account = this.ui.changePasswordAccountNoSpan.text()

            let failMessage;
            if (apiType == 'change_readonly_password' && backendErrorCode == 'password-0001') {
                failMessage = window.translations.readonly_password_must_differ;
            } else if (apiType == 'change_password' && backendErrorCode == 'password-0001') {
                failMessage = window.translations.account_password_must_differ;
            } else {
                failMessage = window.translations.ChangePassword_Toast_Fail;
            }
            
            const html = window.translations.AccountNo + ' ' + mt4Account + '<br/>' + failMessage
            this.ui.toastFailText.html(html)
            this.ui.toastFail.addClass('show')

            const that = this
            setTimeout(() => {
                that.ui.toastFail.removeClass('show')
            }, 5000)
        },
    });
});
